<template>
  <div class="container-fluid bg-dark py-5 mt-5 text-white-50 footer wow fadeIn" data-wow-delay="0.1s">
    <div class="container">
      <div class="row g-5">
        <div class="col-lg-3 col-sm-6">
          <h5 class="text-white mb-4">Get In Touch</h5>
          <p class="mb-2"><i class="fa fa-map-marker-alt me-3"></i>Remera, Kigali - Rwanda</p>
          <p class="mb-2"><i class="fa fa-phone-alt me-3"></i>+250 789 326 245</p>
          <p class="mb-2"><i class="fa fa-envelope me-3"></i>info@estaterwanda.com</p>
          <div class="d-flex pt-2">
            <a class="btn btn-outline-light btn-social" href="#"><i class="fab fa-twitter"></i></a>
            <a class="btn btn-outline-light btn-social" href="#"><i class="fab fa-facebook-f"></i></a>
            <a class="btn btn-outline-light btn-social" href="#"><i class="fab fa-youtube"></i></a>
            <a class="btn btn-outline-light btn-social" href="#"><i class="fab fa-linkedin-in"></i></a>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <h5 class="text-white mb-4">Quick Links</h5>
          <router-link class="btn btn-link text-white-50" to="/about">About Us</router-link>
          <router-link class="btn btn-link text-white-50" to="/contact">Contact Us</router-link>
          <router-link class="btn btn-link text-white-50" to="/services">Our Services</router-link>
          <router-link class="btn btn-link text-white-50" to="/privacy">Privacy Policy</router-link>
          <router-link class="btn btn-link text-white-50" to="/terms">Terms & Condition</router-link>
        </div>
        <div class="col-lg-3 col-sm-6">
          <h5 class="text-white mb-4">Photo Gallery</h5>
          <div class="row g-2 pt-2">
            <div v-for="image in galleryImages" :key="image" class="col-4">
              <img class="img-fluid rounded bg-light p-1" :src="image" alt="Gallery Image" />
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <h5 class="text-white mb-4">Newsletter</h5>
          <!-- <p class="text-muted">Dolor amet sit justo amet elitr clita ipsum sit.</p> -->
          <div class="position-relative mx-auto" style="max-width: 400px">
            <input
              v-model="newsletterEmail"
              class="form-control bg-transparent w-100 py-3 ps-4 pe-5"
              type="email"
              placeholder="Your email"
            />
            <button
              type="button"
              class="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
              @click="handleNewsletterSignup"
            >
              SignUp
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="copyright">
        <div class="row">
          <div class="col-sm-6 text-center text-sm-start mb-3 mb-sm-0">
            © <router-link class="border-bottom" to="/">Estate Rwanda</router-link>, All Rights Reserved.
            Designed By <a class="border-bottom" href="https://tambagroup.xyz">Tamba Group</a>
          </div>
          <div class="col-sm-6 text-center text-sm-end">
            <div class="footer-menu">
              <router-link to="/">Home</router-link>
              <router-link to="/cookies">Cookies</router-link>
              <router-link to="/help">Help</router-link>
              <router-link to="/faqs">FAQs</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  setup () {
    const newsletterEmail = ref('')
    const galleryImages = ref([
      '/img/property-1.jpg',
      '/img/property-2.jpg',
      '/img/property-3.jpg',
      '/img/property-4.jpg',
      '/img/property-5.jpg',
      '/img/property-6.jpg'
    ])

    const handleNewsletterSignup = () => {
      console.log('Newsletter Signup:', newsletterEmail.value)
    }

    return {
      newsletterEmail,
      galleryImages,
      handleNewsletterSignup
    }
  }
})
</script>

<style scoped>
.footer {
  margin-top: 0
}
</style>
